import { Component, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonContext,
  ButtonType,
  GenericButtonComponent,
  ModalMode,
} from '@solcre-org/core-ui';

@Component({
  selector: 'app-voyage-routes-placeholder',
  imports: [GenericButtonComponent, TranslateModule],
  templateUrl: './voyage-routes-placeholder.html',
})
export class VoyageRoutesPlaceholder {
  //Input and outputs
  addPortCall = output<void>();

  //Models
  buttonTypes = ButtonType;
  buttonContexts = ButtonContext;
  modalmodes = ModalMode;

  //Events
  onAddPortCall(): void {
    this.addPortCall.emit();
  }
}
